<template>
  <div class="flex h-[65px] items-center justify-end rounded-[20px] bg-white-gray px-6 pr-20">
    <StatusSelect
      label="Сортировка:"
      :options="optionsList"
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import StatusSelect from "~/components/orders/StatusSelect.vue";

type Option = { label: string; value: string };

const props = withDefaults(
  defineProps<{
    modelValue: string;
    options?: Option[];
  }>(),
  {
    options: () => [],
  }
);

defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const defaultOptions: Option[] = [
  { label: "Сначала недорогие", value: "cheap-first" },
  { label: "Сначала дорогие", value: "expensive-first" },
  { label: "По наименованию (от А до Я)", value: "name-asc" },
  { label: "По наименованию (от Я до А)", value: "name-desc" },
];

const optionsList = computed<Option[]>(() =>
  props.options && props.options.length ? props.options : defaultOptions
);
</script>
